import React, { Fragment, useState, useCallback } from 'react';
import Container from './QuestionnaireContainer';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from '../../../../utils/portal/Portal';
import { areas } from 'constants/areas';
import { getInt } from '../../../../utils/functions';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import { withAreaGetter } from '../../../../providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { NEW_VERSION_QUESTIONNAIRE, DUPLICATE_QUESTIONNAIRE } from '../../mutations';
import { NEW_VERSION_QUESTIONNAIRE_SUBSCRIPTION, DUPLICATE_QUESTIONNAIRE_SUBSCRIPTION } from '../../subscriptions';
import { useApolloClient } from '@apollo/client';
import { useMutation, useSubscription } from 'hooks/apollo';
import { ADMIN_QUESTIONNAIRES } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const [title, setTitle] = useState('');
  const client = useApolloClient();
  const questionnaireId = match.params.questionnaireId && getInt(match.params.questionnaireId);

  const onClickClose = () => {
    historyContext.push(`/questionnaires`);
  };

  const onChangeQuestionnaireTitle = useCallback(questionnaireTitle => {
    setTitle(questionnaireTitle);
  }, []);

  const onRedirect = useCallback(
    questionnaireId => {
      historyContext.push(`/questionnaires/${questionnaireId}`);
    },
    [historyContext]
  );

  const redirectCallback = useCallback(
    questionnaireId => {
      if (questionnaireId) onRedirect(questionnaireId);
    },
    [onRedirect]
  );

  const [DuplicateQuestionnaire] = useMutation(DUPLICATE_QUESTIONNAIRE);

  useSubscription(DUPLICATE_QUESTIONNAIRE_SUBSCRIPTION, {
    onData: data => {
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'questionnaires' });
      client.cache.gc();
      redirectCallback(data.data.data.duplicateQuestionnaireUpdated.questionnaireId);
    }
  });

  const onDuplicate = useCallback(() => {
    DuplicateQuestionnaire({ variables: { input: { questionnaireId: questionnaireId } } });
  }, [DuplicateQuestionnaire, questionnaireId]);

  const [NewVersionQuestionnaire] = useMutation(NEW_VERSION_QUESTIONNAIRE);

  useSubscription(NEW_VERSION_QUESTIONNAIRE_SUBSCRIPTION, {
    onData: data => {
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'questionnaires' });
      client.cache.gc();
      redirectCallback(data.data.data.newVersionQuestionnaireUpdated.questionnaireId);
    }
  });
  const onNewVersion = useCallback(() => {
    NewVersionQuestionnaire({ variables: { input: { questionnaireId: questionnaireId } } });
  }, [NewVersionQuestionnaire, questionnaireId]);

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} questionnaireId={questionnaireId} onDuplicate={onDuplicate} onNewVersion={onNewVersion} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_QUESTIONNAIRES}>
        <Container questionnaireId={questionnaireId} onChangeQuestionnaireTitle={onChangeQuestionnaireTitle} onRedirect={onRedirect} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
